export default __webpack_public_path__ + "static/media/okay.82ec7417.svg";